import { cn } from '@repo/lib/cn';
import { XIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';

import type { RemoveFloatButtonProps } from '.';

export function RemoveFloatButton(removeFloatButtonProps: RemoveFloatButtonProps) {
  const { className, editor, pos, onClick, ...props } = removeFloatButtonProps;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (!editor || pos === undefined) return;
    event.stopPropagation();
    onClick?.(event);
    editor
      .chain()
      .focus()
      .deleteRange({ from: pos, to: pos + 1 })
      .run();
  };

  return (
    <Button type="button" className={cn('absolute top-1.5 right-1.5 z-10 h-5.5 min-h-5.5 w-5.5 min-w-5.5 rounded-md', className)} variant="tertiary" size="sm" onClick={handleClick} {...props}>
      <XIcon />
    </Button>
  );
}
